import { payable, settleable } from '../../lib/proformaState.ts';

export interface PaymentActionFacts {
  status: string;
  paidAmount: number | null;
}

export function paymentActions(invoice: PaymentActionFacts): {
  settle: boolean;
  addReport: boolean;
} {
  return {
    settle: settleable(invoice.status, invoice.paidAmount),
    addReport: payable(invoice.status),
  };
}
